import { t, type I18nLocale } from '@ardoq/i18n';

export const getDefaultOverviewName = (
  startType: string,
  i18nLocale: I18nLocale
): string =>
  t(
    i18nLocale,
    'viewpoints:defaultOverviewName',
    { componentType: startType },
    `${startType} overview`
  );
